import { CommonBoardId } from 'as-ui-kit/const';

import { getSupportedLocale } from './locale';

const colorPickerForegroundWhite = 'var(--glz-color-neutral-tone-0)'; // dark colors - white font
const colorPickerForegroundBlack = 'var(--glz-color-neutral-tone-5)'; // bright colors - black font

const hexToRgbA = hex => {
    let c;

    let rgba = hex || 'var(--glz-color-neutral-tone-5)';
    rgba = rgba.replace(';', '').replace(' ', '').replace('#', '');
    rgba = '#' + rgba;

    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(rgba)) {
        c = rgba.substring(1).split('');

        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }

        c = '0x' + c.join('');

        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',1)';
    }

    throw new Error('Bad Hex');
};

const parseRgbaString = str => {
    // convert rgba(1,2,3,1) to object {r: 1, g: 2, b: 3, a: 1}
    const result = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(1|0\.\d+))?\)$/.exec(str);

    return result ? { r: parseInt(result[1]), g: parseInt(result[2]), b: parseInt(result[3]) } : { r: 0, g: 0, b: 0 };
};

export const getContrastColor = color => {
    const contrastColor = parseRgbaString(hexToRgbA(color));
    const a = 1 - (0.299 * contrastColor.r + 0.587 * contrastColor.g + 0.114 * contrastColor.b) / 255;

    return a < 0.5 ? colorPickerForegroundBlack : colorPickerForegroundWhite;
};

export const getBoardInfo = boardData => {
    if (!boardData) {
        return null;
    }

    if (boardData.id === CommonBoardId) {
        return getCommonBoard();
    }

    return {
        bgColor: boardData.color || colorPickerForegroundBlack,
        color: boardData.id === CommonBoardId ? colorPickerForegroundWhite : colorPickerForegroundBlack,
        id: boardData.id,
        name: boardData.name ?? boardData.originalName,
    };
};

export const sortBoards = (arr, considerTime) => {
    if (!arr || arr.length === 0) {
        return arr;
    }

    let commonBoard = {};
    let newArr = arr.slice();

    const commonBoardIndex = newArr.findIndex(el => el.BoardId === CommonBoardId);

    if (commonBoardIndex !== -1) {
        commonBoard = newArr[commonBoardIndex];
        newArr.splice(commonBoardIndex, 1);
    }

    if (considerTime) {
        const dateReverseCompare = (a, b) => new Date(a.PublicationTime) - new Date(b.PublicationTime);
        newArr = newArr.sort(dateReverseCompare);
    }

    if (commonBoardIndex !== -1) {
        newArr.unshift(commonBoard);
    }

    return newArr;
};

export const getCommonBoard = (locale = 'ru') => {
    const commonBoardName = {
        ru: 'Биржа (Общая площадка)',
        en: 'Exchange (Common Platform)',
    };

    return {
        color: 'white',
        bgColor: 'var(--glz-color-neutral-tone-4)',
        id: 'a0a0a0a0a0a0a0a0a0a0a0a0',
        name: commonBoardName[getSupportedLocale(locale)],
        typeName: 'Грузы для вас',
    };
};
